import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1154px;
  width: 100%;
`